import clsx from 'clsx';
import Style from './container.module.scss';
import { useNode } from '@craftjs/core';
import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';
import { TitlePanel, LayoutPanel } from 'src/features/generalForms/builder/layout/panels';

export const Container: FormContainerComponent = ({ children, title }) => {
  const { connectors, styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;

  return (
    <div ref={(ref) => connect(drag(ref!))}>
      {title && <div className={Style.title}>{title}</div>}
      <div className={clsx(Style.container, 'form-fill--container')} style={styles}>
        {children}
      </div>
    </div>
  );
};

const ContainerSettings = () => (
  <>
    <TitlePanel sections={['Title']} />
    <LayoutPanel sections={['ContentLayout', 'Paddings', 'HorizontalAlignment', 'VerticalAlignment']} />
  </>
);

Container.craft = {
  displayName: 'Container',
  rules: {
    canDrag: () => true,
  },
  related: {
    settings: ContainerSettings,
  },
};
